/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

import clipboard from 'clipboard';

function copyText(_text) {
  var div = document.createElement("div");
  var clip = new clipboard(div, {
    text: function text() {
      return _text;
    }
  });
  div.click();
  clip.destroy();
  div.remove();
}

export { copyText as default };
//# sourceMappingURL=clipboard.js.map
